import { get, destroy, upload, uploadPut } from 'utils/fetchRequest';

export const getEpcPackages = async () => {
    try {
        return await get('epc-packages');
    } catch (err) {
        return { error: err };
    }
};

export const getEpcPackage = async (id) => {
    try {
        return await get(`epc-packages/${id}`);
    } catch (err) {
        return { error: err };
    }
};

export const createEpcPackage = async (formData) => {
    try {
        return await upload('epc-packages', formData);
    } catch (err) {
        return { error: err };
    }
};

export const updateEpcPackage = async (id, formData) => {
    try {
        return await uploadPut(`epc-packages/${id}`, formData);
    } catch (err) {
        return { error: err };
    }
};

export const deleteEpcPackage = async (id) => {
    try {
        return await destroy(`epc-packages/${id}`);
    } catch (err) {
        return { error: err };
    }
};
